
export default {
  name: 'OrderPageSkeleton'
}
